(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    (function () {
    var body = document.body;
    if (!body || !body.classList.contains('anim-enabled')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var root = document.getElementById('main-content') || body;
    var SELECTORS = [
      '.section__header',
      '.card-product',
      '.collection-card',
      '.category-card',
      '.icon-item',
      '.stat',
      '.iwt__media',
      '.iwt__text',
      '.rtws__left',
      '.rtws__right'
    ];

    var nodes = Array.prototype.slice.call(root.querySelectorAll(SELECTORS.join(',')));
    if (!nodes.length) return;

    document.documentElement.classList.add('js-anim');
    body.classList.add('js-anim');

    nodes.forEach(function (el) {
      el.setAttribute('data-reveal', '');
    });

    nodes.forEach(function (el) {
      var parent = el.parentElement;
      if (!parent) return;
      var sibs = Array.prototype.filter.call(parent.children, function (c) {
        return c.hasAttribute && c.hasAttribute('data-reveal');
      });
      var idx = sibs.indexOf(el);
      if (idx > 0) {
        el.style.transitionDelay = Math.min(idx * 80, 320) + 'ms';
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
        countUp(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (el) { io.observe(el); });

    function countUp(container) {
      if (!container.querySelectorAll) return;
      var vals = container.querySelectorAll('.rtws__stat-value');
      Array.prototype.forEach.call(vals, function (node) {
        if (node.dataset.counted) return;
        var raw = node.textContent.trim();
        var m = raw.match(/^(\D*)(\d[\d\s.,]*)(.*)$/);
        if (!m) return;
        var prefix = m[1] || '';
        var numStr = m[2].replace(/\s/g, '').replace(',', '.');
        var suffix = m[3] || '';
        var target = parseFloat(numStr);
        if (isNaN(target)) return;
        var decimals = (numStr.split('.')[1] || '').length;
        node.dataset.counted = '1';
        var dur = 1100;
        var start = null;
        node.textContent = prefix + (0).toFixed(decimals) + suffix;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          if (p < 1) {
            node.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
            requestAnimationFrame(step);
          } else {
            node.textContent = raw;
          }
        }
        requestAnimationFrame(step);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function bssNotify() {
      try {
        if (window.BSS_B2B && BSS_B2B.observer) {
          if (BSS_B2B.observer.productSubject) {
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }
          if (BSS_B2B.observer.cartSubject) {
            BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
          }
        }
      } catch (e) {}
    }

    var Cart = {
      root: null,
      body: null,
      footer: null,
      busy: false,

      init: function () {
        this.root = document.querySelector('[data-cart-drawer]');
        if (!this.root || this.root.dataset.bound) return;
        this.root.dataset.bound = '1';
        this.body = this.root.querySelector('[data-cart-body]');
        this.footer = this.root.querySelector('[data-cart-footer]');
        var self = this;

        // Fermeture : overlay, bouton croix, et tout [data-drawer-close] (y compris injecté)
        this.root.addEventListener('click', function (e) {
          if (e.target.closest('[data-drawer-close]')) self.close();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.root.classList.contains('is-open')) self.close();
        });

        // Icône panier du header → ouvre le tiroir
        document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
          el.addEventListener('click', function (e) {
            e.preventDefault();
            self.open();
          });
        });

        // Quantité +/- et suppression (délégation)
        this.body.addEventListener('click', function (e) {
          var step = e.target.closest('[data-qty-action]');
          if (step) {
            var line = step.closest('[data-line-key]');
            var input = line.querySelector('[data-qty-input]');
            var v = parseInt(input.value, 10) || 0;
            v = step.dataset.qtyAction === 'plus' ? v + 1 : Math.max(0, v - 1);
            self.change(line.dataset.lineKey, v);
            return;
          }
          var rm = e.target.closest('[data-line-remove]');
          if (rm) {
            var l = rm.closest('[data-line-key]');
            self.change(l.dataset.lineKey, 0);
          }
        });
        this.body.addEventListener('change', function (e) {
          var input = e.target.closest('[data-qty-input]');
          if (input) {
            var line = input.closest('[data-line-key]');
            self.change(line.dataset.lineKey, Math.max(0, parseInt(input.value, 10) || 0));
          }
        });
      },

      open: function () {
        if (!this.root) return;
        this.refresh();
        this.root.classList.add('is-open');
        this.root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('drawer-open');
        var panel = this.root.querySelector('.drawer__panel');
        if (panel) panel.focus();
      },

      close: function () {
        if (!this.root) return;
        this.root.classList.remove('is-open');
        this.root.setAttribute('aria-hidden', 'true');
        if (!document.querySelector('.drawer.is-open')) {
          document.documentElement.classList.remove('drawer-open');
        }
      },

      refresh: function () {
        var self = this;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { self.render(cart); return cart; });
      },

      addItem: function (items) {
        var self = this;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function () { return self.refresh(); })
          .then(function (cart) { self.open(); return cart; });
      },

      change: function (key, qty) {
        var self = this;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) { self.render(cart); return cart; });
      },

      updateCount: function (count) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.hidden = count < 1;
        });
      },

      lineHTML: function (item) {
        var d = this.root.dataset;
        var opts = '';
        if (!item.product_has_only_default_variant && item.options_with_values) {
          opts = '<ul class="drawer-cart__variants">' + item.options_with_values.map(function (o) {
            return '<li>' + escapeHtml(o.value) + '</li>';
          }).join('') + '</ul>';
        }
        var img = item.image
          ? '<img src="' + item.image + '" alt="" loading="lazy" width="72" height="72">'
          : '';
        return '' +
          '<div class="drawer-cart__line" data-line-key="' + escapeHtml(item.key) + '">' +
            '<a class="drawer-cart__media" href="' + escapeHtml(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
            '<div class="drawer-cart__info">' +
              '<a class="drawer-cart__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
              opts +
              '<div class="drawer-cart__row">' +
                '<div class="qty-stepper">' +
                  '<button type="button" class="qty-stepper__btn" data-qty-action="minus" aria-label="-">&minus;</button>' +
                  '<input class="qty-stepper__input" type="number" min="0" value="' + item.quantity + '" data-qty-input aria-label="' + escapeHtml(d.qtyLabel) + '">' +
                  '<button type="button" class="qty-stepper__btn" data-qty-action="plus" aria-label="+">+</button>' +
                '</div>' +
                '<span class="drawer-cart__price" bss-b2b-cart-item-key="' + escapeHtml(item.key) + '" bss-b2b-final-line-price>' + money(item.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="drawer-cart__remove" data-line-remove aria-label="' + escapeHtml(d.removeText) + '">' +
              '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>' +
            '</button>' +
          '</div>';
      },

      render: function (cart) {
        this.updateCount(cart.item_count);
        if (!this.body) return;
        var d = this.root.dataset;

        if (!cart.items || cart.items.length === 0) {
          this.body.innerHTML =
            '<div class="drawer-cart__empty">' +
              '<p>' + escapeHtml(d.emptyText) + '</p>' +
              '<a class="btn btn--outline" href="' + escapeHtml(d.continueUrl) + '">' + escapeHtml(d.continueText) + '</a>' +
            '</div>';
          if (this.footer) this.footer.hidden = true;
          bssNotify();
          return;
        }

        var self = this;
        this.body.innerHTML = cart.items.map(function (item) { return self.lineHTML(item); }).join('');
        if (this.footer) {
          this.footer.hidden = false;
          var sub = this.footer.querySelector('[data-cart-subtotal]');
          if (sub) sub.textContent = money(cart.total_price);
        }
        bssNotify();
      }
    };

    window.MorphoCart = Cart;
    if (document.readyState !== 'loading') Cart.init();
    else document.addEventListener('DOMContentLoaded', function () { Cart.init(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
    function bssNotify() {
      try {
        if (window.BSS_B2B && BSS_B2B.observer) {
          if (BSS_B2B.observer.productSubject) {
            BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
          }
        }
      } catch (e) {}
    }

    var QA = {
      root: null,
      data: null,
      selected: [],
      els: {},

      init: function () {
        this.root = document.querySelector('[data-quick-add-drawer]');
        if (!this.root || this.root.dataset.bound) return;
        this.root.dataset.bound = '1';
        var self = this;
        this.els = {
          image: this.root.querySelector('[data-qa-image]'),
          imageLink: this.root.querySelector('[data-qa-image-link]'),
          title: this.root.querySelector('[data-qa-title]'),
          price: this.root.querySelector('[data-qa-price]'),
          compare: this.root.querySelector('[data-qa-compare]'),
          options: this.root.querySelector('[data-qa-options]'),
          qtyInput: this.root.querySelector('[data-qa-qty-input]'),
          submit: this.root.querySelector('[data-qa-submit]')
        };

        // Fermeture
        this.root.addEventListener('click', function (e) {
          if (e.target.closest('[data-drawer-close]')) self.close();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.root.classList.contains('is-open')) self.close();
        });

        // Stepper quantité
        this.root.addEventListener('click', function (e) {
          var step = e.target.closest('[data-qty-action]');
          if (!step) return;
          var v = parseInt(self.els.qtyInput.value, 10) || 1;
          v = step.dataset.qtyAction === 'plus' ? v + 1 : Math.max(1, v - 1);
          self.els.qtyInput.value = v;
        });

        // Changement d'option
        this.els.options.addEventListener('change', function () { self.onOptionChange(); });

        // Ajout au panier
        this.els.submit.addEventListener('click', function () { self.submit(); });

        // Déclencheurs sur les cartes produit (délégation globale)
        document.addEventListener('click', function (e) {
          var trigger = e.target.closest('[data-quick-add-trigger]');
          if (!trigger) return;
          e.preventDefault();
          var card = trigger.closest('.card-product');
          var script = card && card.querySelector('[data-quick-add-json]');
          if (!script) return;
          var data;
          try { data = JSON.parse(script.textContent); } catch (err) { return; }
          if (!data.variants || !data.variants.length) return;
          if (data.has_only_default_variant) {
            self.addDirect(trigger, data.variants[0].id);
          } else {
            self.open(data);
          }
        });
      },

      addDirect: function (trigger, variantId) {
        if (!window.MorphoCart) return;
        trigger.setAttribute('aria-busy', 'true');
        var done = function () { trigger.removeAttribute('aria-busy'); };
        window.MorphoCart.addItem([{ id: variantId, quantity: 1 }]).then(done, done);
      },

      open: function (data) {
        this.data = data;
        var def = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
        this.selected = def ? def.options.slice() : [];

        if (this.els.image) { this.els.image.src = data.image || ''; this.els.image.alt = data.title || ''; }
        if (this.els.imageLink) this.els.imageLink.href = data.url;
        if (this.els.title) { this.els.title.textContent = data.title; this.els.title.href = data.url; }
        if (this.els.price) this.els.price.setAttribute('bss-b2b-product-id', data.id);
        this.els.qtyInput.value = 1;

        this.renderOptions();
        this.update();

        this.root.classList.add('is-open');
        this.root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('drawer-open');
        var panel = this.root.querySelector('.drawer__panel');
        if (panel) panel.focus();
      },

      close: function () {
        this.root.classList.remove('is-open');
        this.root.setAttribute('aria-hidden', 'true');
        if (!document.querySelector('.drawer.is-open')) {
          document.documentElement.classList.remove('drawer-open');
        }
      },

      renderOptions: function () {
        var self = this;
        this.els.options.innerHTML = this.data.options.map(function (opt, idx) {
          var values = opt.values.map(function (val) {
            var checked = self.selected[idx] === val ? ' checked' : '';
            return '' +
              '<label class="quick-add__swatch">' +
                '<input type="radio" name="qa-option-' + idx + '" value="' + esc(val) + '" data-option-index="' + idx + '"' + checked + '>' +
                '<span>' + esc(val) + '</span>' +
              '</label>';
          }).join('');
          return '' +
            '<fieldset class="quick-add__option" data-option-index="' + idx + '">' +
              '<legend class="quick-add__option-name">' + esc(opt.name) + '</legend>' +
              '<div class="quick-add__values">' + values + '</div>' +
            '</fieldset>';
        }).join('');
        this.updateAvailability();
      },

      getSelected: function () {
        var sel = this.selected.slice();
        this.els.options.querySelectorAll('input[type=radio]:checked').forEach(function (input) {
          sel[parseInt(input.dataset.optionIndex, 10)] = input.value;
        });
        return sel;
      },

      findVariant: function (sel) {
        return this.data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        })[0];
      },

      onOptionChange: function () {
        this.selected = this.getSelected();
        this.updateAvailability();
        this.update();
      },

      updateAvailability: function () {
        var self = this;
        var sel = this.getSelected();
        this.els.options.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
          var idx = parseInt(fs.dataset.optionIndex, 10);
          fs.querySelectorAll('input[type=radio]').forEach(function (input) {
            var test = sel.slice();
            test[idx] = input.value;
            var v = self.data.variants.filter(function (vr) {
              return vr.options.every(function (o, i) { return test[i] == null || o === test[i]; });
            })[0];
            var ok = !!(v && v.available);
            input.disabled = !ok;
            var swatch = input.closest('.quick-add__swatch');
            if (swatch) swatch.classList.toggle('is-unavailable', !ok);
          });
        });
      },

      update: function () {
        var d = this.root.dataset;
        var variant = this.findVariant(this.getSelected());
        var price = this.els.price;
        var compare = this.els.compare;
        var submit = this.els.submit;

        if (!variant) {
          if (price) price.textContent = '';
          if (compare) compare.hidden = true;
          submit.disabled = true;
          submit.removeAttribute('data-variant-id');
          submit.textContent = d.selectText;
          return;
        }

        if (price) {
          price.setAttribute('bss-b2b-variant-id', variant.id);
          price.textContent = money(variant.price);
        }
        if (compare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.textContent = money(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
        submit.dataset.variantId = variant.id;
        if (variant.available) {
          submit.disabled = false;
          submit.textContent = d.addText;
        } else {
          submit.disabled = true;
          submit.textContent = d.soldoutText;
        }
        bssNotify();
      },

      submit: function () {
        var variantId = parseInt(this.els.submit.dataset.variantId, 10);
        if (!variantId || !window.MorphoCart) return;
        var qty = Math.max(1, parseInt(this.els.qtyInput.value, 10) || 1);
        var self = this;
        this.els.submit.disabled = true;
        this.els.submit.setAttribute('aria-busy', 'true');
        window.MorphoCart.addItem([{ id: variantId, quantity: qty }]).then(function () {
          self.els.submit.removeAttribute('aria-busy');
          self.close();
        }, function () {
          self.els.submit.disabled = false;
          self.els.submit.removeAttribute('aria-busy');
        });
      }
    };

    window.MorphoQuickAdd = QA;
    if (document.readyState !== 'loading') QA.init();
    else document.addEventListener('DOMContentLoaded', function () { QA.init(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
